<template>
    <Modal class="address-modal"
           data-component="AddressModal"
           size="lg"
           icon="fa-user"
           title="ADDRESS.ADD_ADDRESS">
        <template v-slot:default>
            <div v-if="error"
                 class="alert alert-danger">
                <i class="fa-solid fa-exclamation-circle"></i>
                {{ l('ADDRESS.ADD_ADDRESS_ERROR') }}
            </div>

            <form id="customer-form"
                  novalidate
                  @submit.prevent="ok">
                <div class="form-horizontal">
                    <div class="form-group row">
                        <label class="col-sm-2 control-label control-label-lg">
                            {{ l('CUSTOMER_DETAILS.ADDRESS') }}
                        </label>
                        <div class="col-sm-10">
                            <AddressForm :address="address" />
                        </div>
                    </div>
                    <div class="col-sm-10 col-sm-offset-2">
                        <small>
                            {{ l('ADDRESS.ADD_ADDRESS_GIFT_AID_MESSAGE') }}
                        </small>
                    </div>
                </div>
            </form>
        </template>

        <template v-slot:footer>
            <div class="modl-footer">
                <button class="btn btn-lg btn-default cancel-btn"
                        @click="cancel">
                    {{ l('CANCEL') }}
                </button>
                <button class="btn btn-lg btn-primary"
                        @click="ok">
                    {{ l('SAVE') }}
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>
import AddressForm from '@/epos/vue/components/AddressForm/AddressForm';
import Modal from '@/vue/components/Modals/Modal';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: {
        Modal,
        AddressForm,
    },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        address: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            error: false,
        };
    },

    methods: {
        ok() {
            if (!this.validate()) {
                this.error = true;
                return;
            }

            this.resolve({
                address: this.address,
            });
        },

        validate() {
            // Address must represent a unique property (you must supply house and postcode, or house, street and town).
            if (
                (
                    this.address.house.trim() === ''
                    || this.address.postcode.trim() === ''
                )
                && (
                    this.address.house.trim() === ''
                    || this.address.street.trim() === ''
                    || this.address.town.trim() === ''
                )
            ) {
                return false;
            }
            return true;
        },
    },
};
</script>
